const departments = {
    leader: 'Керівник',
    leaders: 'Керівники відділу',
    led_departments: 'Підпорядковані відділи',
    edit_leaders: 'Налаштувати керівників',
    add_leader: 'Додати',
    remove_leader: 'Видалити',
    no_leaders: 'Керівників не призначено',
    local: 'Локальне керування',
    managed_members: 'Учасники в межах керування',
    leader_scope_hint: 'Керуйте складом своїх відділів і підвідділів.',
    leader_permission_hint: 'Керівники керують складом своїх відділів і підвідділів, але не ролями організації чи структурою відділів.',
    primary_synced: 'Основний відділ керується у Feishu.',
    status_active: 'Активний',
    status_suspended: 'Призупинений',
    status_departed: 'Звільнений',
    status_pending: 'Очікує активації',
    search: 'Пошук',
    previous_page: 'Попередня сторінка',
    next_page: 'Наступна сторінка',
    directory_title: 'Учасники організації',
    member_name: 'Учасник',
    search_members: 'Пошук за ім’ям або логіном',
    include_descendants: 'Включити підрозділи',
    no_members: 'Відповідних учасників немає.',
    all_members: 'Усі учасники',
    all_departments: 'Усі відділи',
    edit_member: 'Редагувати відділи',
    add_child: 'Додати підрозділ',
    expand_department: 'Розгорнути {{name}}',
    collapse_department: 'Згорнути {{name}}',
    title: 'Відділи',
    description: 'Керуйте відділами та призначеннями учасників цієї організації.',
    create: 'Створити відділ',
    edit: 'Редагувати відділ',
    name: 'Назва відділу',
    parent: 'Батьківський відділ',
    root: 'Без батьківського відділу',
    id: 'ID відділу',
    members: 'Відділи учасників',
    member_id: 'ID користувача учасника',
    primary: 'Основний відділ',
    none: 'Не задано',
    assignments: 'Призначення відділів',
    no_assignments: 'Призначень відділів ще немає.',
    assignment_hint: 'Призначте локальні відділи й за потреби основний відділ. Призначення з каталогу доступні лише для читання.',
    empty: 'Відділів ще немає.',
    readonly: 'Ви можете переглядати відділи та свої призначення. Для змін зверніться до адміністратора.',
    load_error: 'Не вдалося завантажити дані. Спробуйте ще раз.',
    mutation_error: 'Не вдалося зберегти. Перевірте права, членство та ієрархію відділів.',
    loading: 'Завантаження…',
    synced: 'Керується каталогом',
    choose: 'Пошук відділів',
    organizations_title: 'Організації та відділи',
    organizations_description: 'Виберіть організацію для перегляду або керування її відділами.',
    no_organizations: 'Ви не належите до організації. Зверніться до адміністратора.',
    organization: 'Поточна організація',
    choose_organization: 'Виберіть організацію',
    delete_title: 'Видалити відділ',
    delete_description: 'Видалити «{{name}}»? Спершу перемістіть учасників і дочірні відділи.',
};
export default Object.freeze(departments);
